import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { focusModeOptInResponseSchema, type FocusModeOptInResponse } from "./types";

interface OptInToFocusModeParams {
  shiftId: string;
}

export function useOptInToFocusMode() {
  return useMutation({
    mutationFn: async ({ shiftId }: OptInToFocusModeParams) => {
      return post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/shifts/${shiftId}/focus-mode/opt-in`,
        data: {},
        requestSchema: z.object({}),
        responseSchema: focusModeOptInResponseSchema,
      });
    },
    meta: {
      logErrorMessage: APP_V2_USER_EVENTS.FOCUS_MODE_OPTED_IN,
    },
  });
}

export type { FocusModeOptInResponse };
